import { DataService } from '../dataService';

export const presentationServices = {
  createPresentation: async (data) => {
    try {
      const response = await DataService.post('/presentation', data);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
